import $ from 'jquery';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import autobind from 'class-autobind';

import { getTrueTileAspectRatio } from 'zoomforth_codesbane_viewer/lib/aspect_ratios.js';

import GridTile from './grid_tile.jsx';
import GridTileWrapper from './grid_tile_wrapper.jsx';
import ConditionalLinkFromTile from './conditional_link_from_tile.jsx';
import GridTileActionIndicator from './grid_tile_action_indicator.jsx';
import GridTileVideoInline from './grid_tile_video_inline_container.jsx';
import { getActionIndicatorTypeFromTileData } from 'zoomforth_codesbane_viewer/lib/tile_actions.js';
import { TILE_ACTION_DATA_VIDEO_INLINE } from 'zoomforth_codesbane_viewer/const/tile_actions.js';

class GridTileForMobileWrappedWithLink extends Component {
  
  constructor(props) {
    super(props);
    autobind(this);
  }
  
  setUpTileforLayout(tileWrapperRef) {
    
    const { sizex, sizey, itemType, hasFileIcon } = this.props;

    const $tile = $(tileWrapperRef).find('.tile');
    const trueAspectRatio = getTrueTileAspectRatio({ sizex, sizey });
    const aspectRatio = trueAspectRatio || { sizex, sizey };

    const {
      sizex: trueSizex,
      sizey: trueSizey
    } = aspectRatio;

    if (hasFileIcon) {
      // For PDF's and other files with icons we set the tile height explicitly
      // (non-icon PDF / file tiles--i.e., those with images are sized by the image itself)
      $tile.height($tile.width() / 2);

    } else if (itemType === 'link') {
      // Web Preview (link) tiles on mobile should grow based on the contents in them.

      // calculate the padding between the image and content and double it so
      // we have even padding on top and bottom.
      const additionalPadding = parseInt($tile.find('.link-meta-container').css('paddingTop')) * 2;

      const tileHeightBasedOnContents = (
        additionalPadding +
        $tile.find('.link-title').outerHeight() +
        $tile.find('.link-source').outerHeight() +
        $tile.find('.link-description').outerHeight()
      );

      // we double this since the image takes up half of the tile space on mobile
      $tile.height(tileHeightBasedOnContents * 2);
    } else if (itemType === 'form') {
      $tile.height($tile.find('.tile-form').outerHeight());

    } else if (itemType !== 'text') {
      const tileHeightBasedOnWidthAndAspect = (
        parseFloat(trueSizey) / parseFloat(trueSizex)
      ) * $tile.width();
      $tile.height(tileHeightBasedOnWidthAndAspect);

    }
  }
  
  render() {
    const {
      wrappedLinkTarget,
      wrappedLinkHref,
      shouldShowExternalOpeningMsg,
      hasActionIcon,
      onLinkToVideoClick,
      actionTypeName,
      ...props
      // we do not pull hasVideoIcon out of props, 
      // because it is expected as part of the props object for other fns and components
      // (e.g. getActionIndicatorProps)
      // it would be good to clean some of this stuff up and make props more explicit
    } = this.props;

    const innerTileStyle = {};
    const middleTileWrapperStyle = {};
    const outerTileWrapperStyle = {};
    
    const shouldCaptionBeUnderneath = (
      // PDF and other files should never render their caption underneath
      !this.props.hasFileIcon &&  
      // We only want wide tiles to render caption underneath
      this.props.sizex > this.props.sizey
    );

    const subpageId = this.props.subpage.id;
    
    const actionIndicatorType = getActionIndicatorTypeFromTileData(props);

    const tileLinkHref = wrappedLinkHref;
    const tileLinkTarget = wrappedLinkTarget;
    const doesTileLinkToVideo = props.doesTileLinkToVideo;
            
    return (
      <ConditionalLinkFromTile 
        key={props.uuid} 
        linkTarget={tileLinkTarget} 
        linkHref={tileLinkHref}
        doesTileLinkToVideo={doesTileLinkToVideo}
        onLinkToVideoClick={onLinkToVideoClick}
      >
        <GridTileWrapper
          setUpTileForLayout={this.setUpTileforLayout} 
          {...{ middleTileWrapperStyle, actionTypeName, outerTileWrapperStyle, subpageId, shouldCaptionBeUnderneath, ...props}}
        >
          {
            
            (hasActionIcon && !props.hasVideoIcon && actionIndicatorType) &&
              <GridTileActionIndicator
                indicatorType={actionIndicatorType}
                asset={props.asset}
                // although at the time of this writing innerTileStyle is always an empty object,
                // the following code is more future-proof than just hard-coding `0`
                topOffsetStyle={innerTileStyle.top || 0}
                leftOffsetStyle={innerTileStyle.left || 0}
              />
          }

          {
            actionTypeName == TILE_ACTION_DATA_VIDEO_INLINE ?
              <GridTileVideoInline
                actionTypeName={actionTypeName}
                innerTileStyle={innerTileStyle}
                {...this.props}
              />
            :
              <GridTile
                actionTypeName={actionTypeName}
                innerTileStyle={innerTileStyle}
                shouldCaptionBeUnderneath={shouldCaptionBeUnderneath}
                tileLinkTarget={tileLinkTarget} 
                tileLinkHref={tileLinkHref}
                shouldShowExternalOpeningMsg={shouldShowExternalOpeningMsg}
                doesTileLinkToVideo={doesTileLinkToVideo}
                onLinkToVideoClick={onLinkToVideoClick}
                {...props}
              />
          }
        </GridTileWrapper>
      </ConditionalLinkFromTile>
    );
  }

}

GridTileForMobileWrappedWithLink.propTypes = {
  wrappedLinkTarget: PropTypes.string,
  wrappedLinkHref: PropTypes.string,
  uuid: PropTypes.number.isRequired,
  itemType: PropTypes.string.isRequired,
  hasFileIcon: PropTypes.bool.isRequired,
  hasActionIcon: PropTypes.bool.isRequired,
  sizex: PropTypes.number.isRequired,
  sizey: PropTypes.number.isRequired
};

export default GridTileForMobileWrappedWithLink;
